/* eslint-disable no-unused-vars */
import { useRef, useState, useEffect } from 'react';
import { ImageWithFallback, ParagraphWithTooltip, IconButton } from 'components';
import { DeleteIcon, DeleteIconNew } from 'assets/icons';
import * as S from './SelectedApp.styled';

export const SelectedApp = ({
  img,
  title,
  descrTitle,
  descrSubtitle,
  onDelete,
  fullWidth,
  style = {},
  children,
}) => {
  const descrSubtitleRef = useRef(null);
  const [width, setWidth] = useState(0);
  const isIcon = !!img;

  useEffect(() => {
    if (descrSubtitleRef.current) {
      setWidth(descrSubtitleRef.current.offsetWidth);
    }
  }, [descrSubtitleRef.current, descrTitle]);

  return (
    <S.Box style={style} isIcon={isIcon} isFullWidth={fullWidth}>
      {img && (
        <S.Image>
          <ImageWithFallback width='40px' height='40px' src={img} />
        </S.Image>
      )}
      <S.TextContent isIcon={isIcon}>
        {title && (
          <S.Title>
            <ParagraphWithTooltip text={title} />
          </S.Title>
        )}
        {(descrTitle || descrSubtitle) && (
          <S.Description>
            {descrTitle && (
              <S.DescrTitle ref={descrSubtitleRef}>
                <ParagraphWithTooltip text={descrTitle} />
              </S.DescrTitle>
            )}
            {descrSubtitle && (
              <S.DescrSubTitle titleWidth={width}>
                <ParagraphWithTooltip text={descrSubtitle} />
              </S.DescrSubTitle>
            )}
          </S.Description>
        )}
        {children}
      </S.TextContent>
      <IconButton.SmallSize
        icon={DeleteIconNew}
        onClick={onDelete}
        type={IconButton.btnTypes.internal}
        style={{ marginLeft: 'auto' }}
      />
    </S.Box>
  );
};
